export type OpenXAgentIconProps = {
  width?: number | string;
  height?: number | string;
  fill?: string;
};

export const OpenXAgentIcon = ({ width = 31, height = 30, fill = 'white' }: OpenXAgentIconProps = {}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="OpenX Agent"
    >
      <title>OpenX Agent</title>
      <path
        d="M7.28906 30H0L6.5127 21.6426C7.66225 20.1674 9.43716 19.3037 11.3174 19.3037H15.1875L7.28906 30ZM27.124 30H19.7314L16.2188 24.9014C15.3406 23.6269 15.3697 21.9417 16.292 20.6982L18.0459 18.334L27.124 30ZM29.002 15.6172L31 16.5283L29.002 17.4404L28.0938 19.4453L27.1855 17.4404L25.1875 16.5283L27.1855 15.6172L28.0938 13.6123L29.002 15.6172ZM15.1875 17.3633H11.3174C9.43714 17.3633 7.66225 16.4996 6.5127 15.0244L0 6.66699H7.28906L15.1875 17.3633ZM23.1289 7.89941L27.125 9.72266L23.1289 11.5459L21.3125 15.5566L19.4961 11.5459L15.5 9.72266L19.4961 7.89941L21.3125 3.88867L23.1289 7.89941ZM29.002 2.00488L31 2.91699L29.002 3.82812L28.0938 5.83398L27.1855 3.82812L25.1875 2.91699L27.1855 2.00488L28.0938 0L29.002 2.00488Z"
        fill={fill}
      />
    </svg>
  );
};
